// extracted by mini-css-extract-plugin
export var box = "_7o-1";
export var checkboxRow = "_7o-8";
export var checked = "_7o-2";
export var descriptionSpacer = "_7o-a";
export var disabled = "_7o-3";
export var icon = "_7o-6";
export var input = "_7o-0";
export var labelSpacer = "_7o-9";
export var medium = "_7o-5";
export var small = "_7o-4";
export var text = "_7o-7";